export const tabRowStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  width: 'fit-content',
  maxWidth: '100%',
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-subtle)',
  padding: 4,
  overflowX: 'auto',
};

export const tabButtonStyle = (active) => ({
  border: '0',
  background: active ? 'var(--bg-card)' : 'transparent',
  color: active ? 'var(--text)' : 'var(--text-sub)',
  borderRadius: 6,
  padding: '7px 12px',
  fontSize: 13,
  fontWeight: 800,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
});

export const summaryGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
  gap: 8,
};

export const summaryCardStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  padding: '9px 11px',
  minHeight: 54,
};

export const summaryLabelStyle = {
  fontSize: 11,
  color: 'var(--text-sub)',
  fontWeight: 700,
};

export const summaryValueStyle = {
  marginTop: 2,
  fontSize: 19,
  color: 'var(--text)',
  fontWeight: 900,
  lineHeight: 1.1,
};

export const dashboardGridStyle = (isMobile) => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? '1fr' : 'minmax(260px, 320px) minmax(0, 1fr)',
  gap: 12,
  alignItems: 'start',
});

export const boardPanelStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  minHeight: 520,
  overflow: 'hidden',
};

export const panelHeaderStyle = {
  padding: '10px 12px',
  borderBottom: '1px solid var(--border)',
  background: 'var(--bg-subtle)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 10,
};

export const panelTitleStyle = {
  margin: 0,
  color: 'var(--text)',
  fontSize: 14,
  fontWeight: 900,
  lineHeight: 1.2,
};

export const panelSubStyle = {
  color: 'var(--text-sub)',
  fontSize: 12,
  fontWeight: 700,
  whiteSpace: 'nowrap',
};

export const panelBodyStyle = {
  padding: 10,
};

export const listScrollStyle = {
  maxHeight: 'calc(100vh - 330px)',
  minHeight: 360,
  overflowY: 'auto',
  paddingRight: 2,
};

export const itemGroupHeaderStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  margin: '8px 0 4px',
  padding: '5px 7px',
  border: '1px solid var(--border)',
  borderRadius: 6,
  background: 'var(--bg-subtle)',
  color: 'var(--text)',
  fontSize: 11,
  fontWeight: 900,
  lineHeight: 1.2,
};

export const itemGroupCountStyle = {
  color: 'var(--text-sub)',
  fontSize: 11,
  fontWeight: 850,
};

export const searchStyle = {
  width: '100%',
  boxSizing: 'border-box',
  border: '1px solid var(--border)',
  borderRadius: 7,
  background: 'var(--bg-card)',
  color: 'var(--text)',
  padding: '8px 10px',
  fontSize: 13,
  marginBottom: 8,
  outline: 'none',
};

export const selectableRowStyle = (active) => ({
  width: '100%',
  border: '1px solid transparent',
  borderColor: active ? '#3b82f6' : 'transparent',
  borderRadius: 7,
  background: active ? 'rgba(59,130,246,0.12)' : 'transparent',
  color: 'var(--text)',
  padding: '8px 9px',
  textAlign: 'left',
  cursor: 'pointer',
  marginBottom: 3,
  display: 'block',
});

// 줄 제목(업무 권한 카드의 '상황판' · 직원 이름 등) — 850 에서 한 단계 낮췄다 (2026-09-23 사용자 요청).
//   배정 화면 글자가 전반적으로 너무 두꺼웠다.
export const rowTitleStyle = {
  fontSize: 13,
  fontWeight: 750,
  color: 'var(--text)',
  lineHeight: 1.25,
  wordBreak: 'keep-all',
};

// 줄 아래 작은 설명(SITUATION_BOARD 같은 코드) — 굵기를 빼고 보통 두께로 (2026-09-23 사용자 요청).
//   400 은 위쪽 검색칸(searchStyle)과 같은 두께라 화면 안에서 기준이 맞는다.
export const rowMetaStyle = {
  marginTop: 2,
  fontSize: 11,
  color: 'var(--text-sub)',
  fontWeight: 400,
  lineHeight: 1.25,
  wordBreak: 'break-word',
};

export const chipWrapStyle = {
  display: 'flex',
  gap: 4,
  flexWrap: 'wrap',
  marginTop: 5,
};

export const chipStyle = {
  border: '1px solid var(--border)',
  borderRadius: 6,
  padding: '2px 6px',
  color: 'var(--text-sub)',
  background: 'var(--bg-subtle)',
  fontSize: 11,
  fontWeight: 800,
  lineHeight: 1.2,
};

export const checkGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
  gap: 6,
};

export const checkRowStyle = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto',
  alignItems: 'center',
  gap: 8,
  border: '1px solid var(--border)',
  borderRadius: 7,
  padding: '7px 8px',
  background: 'var(--bg-card)',
  minHeight: 46,
};

export const assignToggleStyle = (assigned) => ({
  border: `1px solid ${assigned ? '#2563eb' : 'var(--border)'}`,
  background: assigned ? '#2563eb' : 'var(--bg-subtle)',
  color: assigned ? '#fff' : 'var(--text-sub)',
  borderRadius: 6,
  padding: '5px 8px',
  minWidth: 58,
  fontSize: 12,
  fontWeight: 850,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
});

export const sectionLabelStyle = {
  margin: '12px 0 7px',
  color: 'var(--text-sub)',
  fontSize: 12,
  fontWeight: 900,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const emptyNoticeStyle = {
  padding: 16,
  color: 'var(--text-sub)',
  textAlign: 'center',
  fontSize: 13,
};

export const diagnosticCardStyle = (severity) => {
  const color = severity === 'danger' ? '#dc2626' : severity === 'warning' ? '#d97706' : '#2563eb';
  return {
    border: `1px solid ${color}`,
    borderLeft: `4px solid ${color}`,
    borderRadius: 8,
    background: 'var(--bg-card)',
    padding: 12,
    marginBottom: 10,
  };
};
